export const filterLocations = (unfilteredLocations, searchTerm) => {
  return !searchTerm
    ? unfilteredLocations
    : unfilteredLocations.filter((location) => {
      const sanitizedSearchTerm = searchTerm.toLowerCase()
      const {
        attention = '',
        addressOne = '',
        addressTwo = '',
        city = '',
        stateCode = '',
        county = '',
        zip = ''
      } = location.address

      return (
        location.name.toLowerCase()
          .includes(sanitizedSearchTerm)
        || (attention && attention.toLowerCase()
          .includes(sanitizedSearchTerm))
        || (addressOne && addressOne.toLowerCase()
          .includes(sanitizedSearchTerm))
        || (addressTwo && addressTwo.toLowerCase()
          .includes(sanitizedSearchTerm))
        || (city && city.toLowerCase()
          .includes(sanitizedSearchTerm))
        || (stateCode && stateCode.toLowerCase()
          .includes(sanitizedSearchTerm))
        || (county && county.toLowerCase()
          .includes(sanitizedSearchTerm))
        || (zip && zip.toLowerCase()
          .includes(sanitizedSearchTerm))
      )
    })
}

export const concatenateAddress = (address) => {
  const result = []
  if (address.address1) {
    result.push(address.address1)
  }
  if (address.address2) {
    result.push(address.address2)
  }
  if (address.city) {
    result.push(address.city)
  }
  if (address.state) {
    result.push(address.state)
  }
  if (address.zip) {
    result.push(address.zip)
  }
  if (address.country) {
    result.push(address.country)
  }
  return result.join(' ')
}
